import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { postService } from '../../services/api';
import Post from '../../components/Post/Post';
import { FiArrowLeft } from 'react-icons/fi';

const PostPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await postService.getPost(id);
        if (response.success) {
          setPost(response.data);
        } else {
          setError('Post not found');
        }
      } catch (err) {
        setError('Failed to load post');
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [id]);

  return (
    <div className="container" style={{ paddingTop: '1rem' }}>
      <button className="back-btn" onClick={() => navigate(-1)}>
        <FiArrowLeft /> Back
      </button>

      {loading ? (
        <div className="loading-state">
          <span className="spinner spinner-lg"></span>
          <p>Loading post...</p>
        </div>
      ) : error ? (
        <div className="error-state card">
          <p>{error}</p>
        </div>
      ) : post ? (
        <Post post={post} />
      ) : null}
    </div>
  );
};

export default PostPage;